import Vue from "vue";
import Router from "vue-router";

// Import your views/pages
import AuthPage from "../views/AuthPage.vue";
import QuestionPage from "../views/QuestionPage.vue";
import DashboardPage from "../views/DashboardPage.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    //base: process.env.BASE_URL, //OK ?
    routes: [
        { 
            path: "/auth", 
            name: "Auth", 
            component: AuthPage 
        },
        // { 
        //     path: "/dashboard", 
        //     name: "Dashboard", 
        //     component: DashboardPage 
        // },
        { 
            path: "/questions/:questionId?", 
            name: "QuestionPage", 
            component: QuestionPage 
        },
        { 
            path: "/dashboard", 
            name: "DashboardPage", 
            component: DashboardPage },
        // Optional: Add a catch-all route
        {
            path: '*',
            redirect: '/auth'
        }
    ],
});


